import axios from "axios";

// For development, use mock data
const USE_MOCK_DATA = true;

const API_URL = process.env.REACT_APP_API_URL || "https://professionalportfolio-9a6n.onrender.com/api";

const apiTimeoutMs =
  Number(process.env.REACT_APP_API_TIMEOUT_MS) ||
  (process.env.NODE_ENV === "production" ? 45000 : 12000);

const api = axios.create({
  baseURL: API_URL,
  timeout: apiTimeoutMs,
  headers: {
    "Content-Type": "application/json",
  },
});

// Mock data for development
const mockData = {
  about: {
    title: "About Me",
    description:
      "I am a passionate developer with experience in web development.",
    imageUrl: "https://via.placeholder.com/300",
  },
  projects: [
    {
      id: 1,
      title: "Portfolio Website",
      description: "A personal portfolio website built with React and .NET",
      imageUrl: "https://via.placeholder.com/300",
      technologies: ["React", ".NET", "MySQL"],
    },
  ],
  skills: {
    technical: ["React", ".NET", "MySQL", "JavaScript"],
    soft: ["Communication", "Problem Solving", "Teamwork"],
  },
};

// Portfolio API endpoints
export const portfolioApi = {
  // About endpoints
  getAbout: () =>
    USE_MOCK_DATA
      ? Promise.resolve({ data: mockData.about })
      : api.get("/portfolio/about"),
  updateAbout: (data) => api.put("/portfolio/about", data),

  // Projects endpoints (always use API so Projects page shows saved data)
  getProjects: () => api.get("/portfolio/projects"),
  getProject: (id) => api.get(`/portfolio/projects/${id}`),
  createProject: (data) => api.post("/portfolio/projects", data),
  updateProject: (id, data) => api.put(`/portfolio/projects/${id}`, data),
  deleteProject: (id) => api.delete(`/portfolio/projects/${id}`),

  // Projects page hero and CTA (public)
  getProjectsPageHero: () => api.get("/portfolio/projects-page/hero"),
  getProjectsPageCTA: () => api.get("/portfolio/projects-page/cta"),

  // Skills endpoints
  getSkills: () =>
    USE_MOCK_DATA
      ? Promise.resolve({ data: mockData.skills })
      : api.get("/portfolio/skills"),
  updateSkills: (data) => api.put("/portfolio/skills", data),
};

export default api;
